import HttpClientXml from "../utils/HttpClientXml";

const createCityDate = async (data) => {
  const endPoint = "city-date";
  return HttpClientXml.post(endPoint, data);
};

const getAllCityDates = async () => {
  const endPoint = "city-date";
  return HttpClientXml.get(endPoint);
};

const getSingleCityDate = async (id) => {
  const endPoint = `city-date/${id}`;
  return HttpClientXml.get(endPoint);
};

const updateCityDate = async (id, data) => {
  const endPoint = `city-date/${id}`;
  return HttpClientXml.put(endPoint, data);
};

const deleteCityDate = async (id) => {
  const endPoint = `city-date/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export default {
  createCityDate,
  getAllCityDates,
  getSingleCityDate,
  updateCityDate,
  deleteCityDate,
};
